// extracted by mini-css-extract-plugin
module.exports = {"termsOfUse":"TermsOfUse_termsOfUse__jfOWq"};